import type { SxProps, Theme } from '../../themes/themes';

export const getStyles = (theme: Theme): { [key: string]: SxProps } => {
  return {
    disablePadding: {
      padding: 0,
    },
    circular: {
      borderRadius: '100%',

      // make the border go inside width/height
      boxSizing: 'border-box',

      // dim = padding * 2 + fontSize
      padding: theme.spacing(4),
      fontSize: theme.spacing(5),
      width: `calc(${theme.spacing(4)} * 2 + ${theme.spacing(5)})`,
      height: `calc(${theme.spacing(4)} * 2 + ${theme.spacing(5)})`,
      [theme.breakpoints.up('lg')]: {
        padding: theme.spacing(5),
        fontSize: theme.spacing(6),
        width: `calc(${theme.spacing(5)} * 2 + ${theme.spacing(6)})`,
        height: `calc(${theme.spacing(5)} * 2 + ${theme.spacing(6)})`,
      },

      color: theme.palette.labeling.tertiaryDefault,
      borderWidth: '1px',
      borderColor: theme.palette.surface.tertiaryDefault,
      backgroundColor: theme.palette.surface.tertiaryDefault,
      '&:hover': {
        color: theme.palette.labeling.tertiaryHover,
        borderWidth: '1px',
        borderColor: theme.palette.surface.tertiaryHover,
        backgroundColor: theme.palette.surface.tertiaryHover,
      },
      '&:focus, &:active': {
        color: theme.palette.labeling.tertiaryActive,
        borderWidth: '1px',
        borderColor: theme.palette.surface.tertiaryActive,
        backgroundColor: theme.palette.surface.tertiaryActive,
      },
      '&:focus-visible': {
        color: theme.palette.labeling.tertiaryDefault,
        borderWidth: '2px',
        borderColor: theme.palette.border.defaultFocus,
        backgroundColor: theme.palette.surface.tertiaryDefault,
      },
    },
  };
};
